import axiosApi from '../../kits/axiosApi';
// import { message } from 'ant-design-vue';

const state = {};
const getters = {};

const actions = {
    get_reward_list({ rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5552' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .get(aj_host + '/weapp/admin/coupon/query_user_coupon', {
                    params: post_data
                })
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        });
    },
    redeem_reward({ rootState }, post_data) {
        let aj_host = rootState.debug ? 'http://127.0.0.1:5552' : '';

        return new Promise((resolve, reject) => {
            axiosApi
                .post(aj_host + '/weapp/admin/coupon/write_off', post_data)
                .then((res) => {
                    resolve(res.data.data)
                })
                .catch((err) => {
                    reject(err)
                })
        });
    }
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
